
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useContext, useState } from "react";
import { DISPLAYPLATFORM, OTT_POSTER_TYPE, RAILTYPE } from "../../constant/constant";
import { PlatformContext } from "../../../Contexts/PlatformContext";
import { utility } from "../../utility/utilityProvider";
import crown from '../Component/Images/crown.png';

const HeroBanner = (props) => {
    const mobile = props.isMobile;
    const { ref } = useFocusable({
        onFocus: () => {
            props.setOttAsset(null);
            ref.current.scrollTo(0, 0);
        }
    });

    const [imgError, setImgError] = useState(false);
    const displayPlatform = useContext(PlatformContext);
    const isWeb = displayPlatform === DISPLAYPLATFORM.WEB;
    const isPortrait = isWeb || props.rail.OttRailTypeSID === RAILTYPE.HeroBannerPotrait;
    const getContainerStyle = () => {
        if (mobile) {
            return { padding: "8px", height: "15vh", width: "auto", background: "transparent", margin: "0px auto", };
        } else {
            return { height: "22vh", width: "100%", maxWidth: "100%", background: "transparent", margin: "0 auto", position: "relative", display: "flex", alignItems: "center", justifyContent: "center", };
        }
    };

    return (
        <div ref={ref}>
            <Swiper
                pagination={{
                    type: 'bullets',
                    clickable: 'true'
                }}
                modules={[Pagination, Autoplay, EffectFade]}
                slidesPerView={1}
                spaceBetween={500}
                centeredSlides={true}
                speed={500}
                direction='horizontal'
                className='mySwiper'
                keyboard={{
                    enabled: true
                }}
                autoplay={{
                    delay: 4000,
                    disableOnInteraction: false
                }}
            >
                {props.rail.OttAsset.map((asset, index) => {
                    const title = asset?.Title?.[0]?.value || asset?.Title;
                    return (
                        <SwiperSlide key={index}>
                            <div className="heroBannerContainer" style={getContainerStyle()}>
                                <img src={utility.getPosterUrl(asset.Posters, isPortrait ? OTT_POSTER_TYPE.Portrait : OTT_POSTER_TYPE.Landscape)}
                                    className="herobanner"
                                    alt="First slide"
                                    style={{ aspectRatio: isPortrait ? "2/3" : "16/9", objectFit: "cover", width: "100%", height: "100%", borderRadius: "12px", background: imgError ? "#716f6fff" : "transparent" }}
                                    onError={(e) => { e.target.onerror = null; e.target.src = props?.ottSetting?.logo; setImgError(true); }}
                                />
                                {!mobile && (
                                    <div style={{ position: "absolute", bottom: "5px", left: "10px", width: "100%" }} >
                                        <p style={{ fontSize: " 18px", fontWeight: "bold", color: "white", marginBottom: "2px", textShadow: "2px 2px 8px rgba(0,0,0,0.6)", }} > {title ?? "ho"} </p>
                                        <div style={{ display: "inline-flex", alignItems: "center", border: "1px solid white", padding: "5px 5px", borderRadius: "4px", cursor: "pointer", backgroundColor: "rgba(0,0,0,0.5)", gap: "5px", transition: "0.3s", width: "80px", height: "20px" }} >
                                            <i className="fa fa-play-circle" style={{ color: "white", fontSize: "10px" }} aria-hidden="true" />
                                            <span style={{ color: "white", fontWeight: "bold", fontSize: "10px", }}>
                                                Watch Now
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

export default HeroBanner;
















